import alerts from '../helpers/storeModuleHelpers/alerts';
import _cloneDeep from 'lodash/cloneDeep';
import axios from 'axios';
import { BASE_URL } from '@/helpers/apiUtilities.js';

export const state = {
  data: [],
  ...alerts.getState()
};

export const mutations = {
  ...alerts.mutations,
  addItem: function (state, item) {
    let quantity = item.quantity;
    if (!quantity) {
      quantity = 1;
    }

    const itemInCart = state.data.find(cartItem => cartItem.id === item.id);
    if (itemInCart) {
      itemInCart.quantity += quantity;
    } else {
      const copiedItem = _cloneDeep(item);
      copiedItem.quantity = quantity;
      state.data.push(copiedItem);
    }
  },
  removeItem: function (state, index) {
    state.data.splice(index, 1);
  },
  updateItemQuantities: function (state, { item, newValue }) {
    const itemInCart = state.data.find(cartItem => cartItem.id === item.id);
    if (itemInCart) {
      itemInCart.quantity = newValue;
    }
  }
};

export const actions = {
  getCheckoutSession: function (store, payload) {
    store.commit('clearAlerts');
    return axios.post(BASE_URL + '/Client/Payments', payload)
      .then(response => {
        if (response?.data?.url) {
          return response.data.url;
        } else {
          const alert = {
            status: 'error',
            message: 'Error checking out:',
            error: 'Checkout url does not exist'
          };

          store.commit('addAlert', alert);
          return null;
        }
      })
      .catch((error) => {
        const alert = {
          status: 'error',
          message: 'Error checking out:',
          error
        };
        store.commit('addAlert', alert);
        return null;
      });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
